import * as firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAC8sZVVLDybS8gW7Y91j-m5_wc_bcjp-s",
    authDomain: "teacher-secret.firebaseapp.com",
    databaseURL: "https://teacher-secret.firebaseio.com",
    projectId: "teacher-secret",
    storageBucket: "teacher-secret.appspot.com",
    messagingSenderId: "503217571630",
    appId: "1:503217571630:web:cd0392ea42a43c47ed5cbf",
    measurementId: "G-8EEBSCLWDK"
};

firebase.initializeApp(firebaseConfig)

firebase.firestore()

export default firebase